/**
 * Image Video CTA Section
 * Handles video playback and interactions
 */

(function() {
  'use strict';

  class ImageVideoCTA {
    constructor(container) {
      this.container = container;
      this.video = container.querySelector('.image-video-cta__video');
      this.init();
    }

    init() {
      if (this.video) {
        // Ensure videos are playing (some browsers may pause autoplay)
        this.ensureVideoPlaying();
        
        // Handle visibility changes (pause when not visible, play when visible)
        this.handleVisibilityChange();
      }
    }

    ensureVideoPlaying() {
      // Ensure video is muted for autoplay
      if (!this.video.muted) {
        this.video.muted = true;
      }

      // Try to play the video
      const playPromise = this.video.play();
      
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // Video is playing
          })
          .catch((error) => {
            // Autoplay was prevented, log for debugging
            console.log('Video autoplay prevented:', error);
          });
      }
    }

    handleVisibilityChange() {
      // Pause video when page is hidden, play when visible
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          if (this.video) {
            this.video.pause();
          }
        } else {
          if (this.video) {
            const playPromise = this.video.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {
                // Ignore play errors
              });
            }
          }
        }
      });
    }

    onUnload() {
      // Cleanup if needed
      if (this.video) {
        this.video.pause();
        this.video.src = '';
        this.video.load();
      }
    }
  }

  // Register with theme sections if available
  if (typeof theme !== 'undefined' && theme.Sections) {
    theme.Sections.prototype.register = theme.Sections.prototype.register || function(type, constructor) {
      this.constructors[type] = constructor;
    };

    theme.Sections.prototype.register('image-video-cta', ImageVideoCTA);
  }

  // Initialize on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function() {
    const imageVideoCTASections = document.querySelectorAll('[data-section-type="image-video-cta"]');
    imageVideoCTASections.forEach((section) => {
      new ImageVideoCTA(section);
    });
  });

  // Handle Shopify section loading
  document.addEventListener('shopify:section:load', function(event) {
    const section = document.querySelector('[data-section-id="' + event.detail.sectionId + '"]');
    if (section && section.getAttribute('data-section-type') === 'image-video-cta') {
      new ImageVideoCTA(section);
    }
  });
})();

